import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import { NOTE_MAIN_DATA, NOTE_CLEAR_DATA } from "./actionTypes";
import { apiError, getMainDataSuccessful } from "./actions";

import {
  // postAdd,
  getList,
  // getParamsList,
  // postEdit,
  // postDelete,
} from "../../helpers/Helper";
// import swal from "sweetalert";

function* getMainData() {
  try {
    const response = yield call(getList, "/system/Notification/", {});
    yield put(getMainDataSuccessful(response.results));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* ClearData() {
  try {
    yield call(getList, "/system/Notification/Clear", {});
  } catch (error) {
    yield put(apiError(error));
  }
}
export function* watchgetMainData() {
  yield takeEvery(NOTE_MAIN_DATA, getMainData);
  yield takeEvery(NOTE_CLEAR_DATA, ClearData);
}
function* NotificationSaga() {
  yield all([fork(watchgetMainData)]);
}

export default NotificationSaga;
